////////////*Feature:Multiple Choice/Single Choice Questions///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

function resetQuiz() {
	var choices = $('#' + globalVar.curSlide + ' .si-quiz__js li');
	choices.removeClass('si-quiz-selected');
}
function initQuiz() {
	for (key in slides) {
		if (slides[key].type === 'quiz') {
			if (slides[key].quiz.radio === 'undefined') {
				slides[key].quiz.radio = false;
			} else if (slides[key].quiz.radio) {
				$('#' + key + ' .si-quiz__js').addClass('si-radio__js');
			}
		}
	}
	var quizzes = $('.si-quiz__js');
	var buttonType = globalVar.buttonType;
	quizzes.each(function (idx, quiz) {
		var $choices = $(quiz).find('li');
		var buttons = $(quiz).find('div');
		var isRadio = $(quiz).hasClass('si-radio__js') ? true : false;
		$choices.each(function (idx, choice) {
			$(choice).addClass('si-quiz-answer').attr('tabindex', '0');
			$(choice).on('click.quiz', function () {
				quizHandleAnswerSelected($(this), $(quiz), $choices, isRadio);
			});
			$(choice).on('keyup.quiz', function () {
				if (event.which === 13) {
					quizHandleAnswerSelected($(this), $(quiz), $choices, isRadio);
				}
			});
		});
		buttons.each(function (idx, button) {
			var image = $(button).children().eq(0);
			if (isRadio) {
				$(image).attr('src', function (index, attr) {
					return attr.replace('mcq', 'scq');
				});
			} else {
				$(image).attr('src', function (index, attr) {
					return attr.replace('scq', 'mcq');
				});
			}

			$(button)
				.find('img')
				.attr('src', function (index, attr) {
					return attr.replace('classic', buttonType);
				});
		});
	});
}
function quizFunction() {
	var slideObj = slides[globalVar.curSlide];
	var answers = slideObj['quiz']['answers'];
	var $choices = $('#' + globalVar.curSlide + ' .si-quiz__js li');

	if (globalVar.lockSubmitIfUnattempted) lockButtonNowUnlockOnExit($('#si-submit'), slideObj);

	if (!slides[globalVar.curSlide]['visited'] && globalVar.devMode) {
		$choices.each(function (idx, choice) {
			if (answers[$(choice).attr('id')]) {
				$(choice).css('color', 'blue');
			}
		});
	} else {
		resetQuiz();
	}
}

function handleSubmitAccess(selectedAnswers, $submit) {
	var $submit = $submit ? $submit : $('#si-submit');
	if (selectedAnswers.length > 0) unlock($submit);
	else lock($submit);
}

function quizHandleAnswerSelected($selectedAnswer, $quiz, $choices, isRadio) {
	siAudio.sfx.click.play();
	if (isRadio) {
		$choices.removeClass('si-quiz-selected');
	}
	if ($selectedAnswer.hasClass('si-quiz-selected')) {
		$selectedAnswer.removeClass('si-quiz-selected');
	} else {
		$selectedAnswer.addClass('si-quiz-selected');
	}

	if (globalVar.lockSubmitIfUnattempted) handleSubmitAccess($quiz.find('.si-quiz-selected'), $('#si-submit'));
}
